import { createBrowserRouter } from "react-router-dom";
import Login from "../pages/auth/Login";
import CustomerRegister from "../pages/auth/CustomerRegister";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import ActivateAccount from "../pages/auth/ActivateAccount";
import EstimateAndDeliveryPlan from "../pages/EstimateAndDeliveryPlan";
import InputCustomerInfo from "../pages/InputCustomerInfo";
import InputInfoConfirmation from "../pages/InputInfoConfirmation";
import Home from "../pages/Home";
import PrivateRoute from "./PrivateRoute";
import CustomerDashboard from "../pages/dashboard/CustomerDashboard";
import SubcontractorDashboard from "../pages/dashboard/SubcontractorDashboard";
import EstimationDisplay from "../pages/EstimationDisplay";
import OrderAcceptanceCompletion from "../pages/OrderAcceptanceCompletion";
import TicketDetail from "../pages/TicketDetail";
import AdminRoute from "./AdminRoute";
import EmployeeDashboard from "../pages/dashboard/EmployeeDashboard";
import AuthorityManagement from "../pages/management/AuthorityManagement";
import CustomerManagement from "../pages/management/CustomerManagement";
import EmployeeManagement from "../pages/management/EmployeeManagement";
import SubcontractorManagement from "../pages/management/SubcontractorManagement";
import SystemSetting from "../pages/system/SystemSetting";
import CustomerRoute from "./CustomerRoute";

//Custom Browser Router for useBlock
const router = createBrowserRouter([
  {
    element: <CustomerRoute />,
    children: [
      { path: "/*", element: <Home /> },
      { path: "/login", element: <Login /> },
      { path: "/forgot-password", element: <ForgotPassword /> },
      { path: "/reset-password", element: <ResetPassword /> },
      { path: "/register", element: <CustomerRegister /> },
      { path: "/account/active/:activeCode", element: <ActivateAccount /> },
      { path: "/estimate-delivery-plan", element: <EstimateAndDeliveryPlan /> },
      { path: "/input-customer-info", element: <InputCustomerInfo /> },
      { path: "/input-info-confirmation", element: <InputInfoConfirmation /> },
    ],
  },
  {
    element: <PrivateRoute />,
    children: [
      { path: "/estimation-display", element: <EstimationDisplay /> },
      {
        path: "/order-acceptance-completion",
        element: <OrderAcceptanceCompletion />,
      },
      { path: "/dashboard/subcontractor", element: <SubcontractorDashboard /> },
      { path: "/dashboard/customer", element: <CustomerDashboard /> },
      { path: "/ticket/:id", element: <TicketDetail /> },
      {
        element: <AdminRoute />,
        children: [
          { path: "/management/employee", element: <EmployeeManagement /> },
          { path: "/management/customer", element: <CustomerManagement /> },
          {
            path: "/management/subcontractor",
            element: <SubcontractorManagement />,
          },
          { path: "/management/authority", element: <AuthorityManagement /> },
          { path: "/dashboard/employee", element: <EmployeeDashboard /> },
          { path: "/management/system", element: <SystemSetting /> },
        ],
      },
    ],
  },
]);

export default router;
